import { type StoreState } from '../../../store'
import { key } from './graphQl.reducer'

const getGraphQlStore = (state: StoreState) => state[key]

export const validationErrors = (state: StoreState) => getGraphQlStore(state).validationErrors
